module.exports = __webpack_public_path__ + "fc922b5185a2d4d0dbf6702fb61129f0.svg";